<template>
  <div>
    <ais-state-results>
      <div
        v-show="hits.length === 0"
        slot-scope="{ results: { hits } }"
      >
        <ais-current-refinements>
          <template #default="{}">
            <article class="card roomy">
              <font-awesome-icon
                :icon="$v6.duotone.faFaceThinking"
                size="4x"
                style="--fa-secondary-opacity: 1; --fa-secondary-color: var(--fa-yellow)"
              />
              <h1 class="margin-y-2xs">No Icons Found</h1>

              <p class="size-lg">There are no icons that match your current filters. Try removing some of them to get better results.</p>

              <button @click.prevent="clearFilters()">Clear All Filters + Start Over</button>
            </article>

            <icons-supplemental-actions :version="version" />
          </template>
        </ais-current-refinements>
      </div>
    </ais-state-results>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectClearRefinements } from 'instantsearch.js/es/connectors'
  import IconsSupplementalActions from 'app/views/icons/components/icons/IconsSupplementalActions'

  export default {
    name: 'NoSearchResults',

    components: {
      IconsSupplementalActions
    },

    mixins: [createWidgetMixin({ connector: connectClearRefinements })],

    props: {
      version: {
        type: Number
      }
    },

    methods: {
      clearFilters() {
        this.state.refine('')
        this.$emit('clearSearch', '')
      }
    }
  }
</script>
